import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-ink-line bg-ink-soft px-5 pb-28 pt-14 sm:px-8" data-id="element-88" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl text-center" data-id="element-89" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-extrabold text-white" data-id="element-90" data-mp="32oe3s5wgktfx">Tu Brújula Digital™</p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-violeta-100/70" data-id="element-91" data-mp="36p6c8wxiaub5">
          El sistema N°1 para salir de una relación tóxica en Argentina. Porque no debería hacerse
          sola, sin mapa y sin herramientas.
        </p>

        <div className="mt-6 flex flex-col items-center justify-center gap-2 text-sm text-violeta-200 sm:flex-row sm:gap-6" data-id="element-92" data-mp="387ddgpep1cm">
          <a href="mailto:soportetubrujuladigital@gmail.com" className="hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violeta-300" data-id="element-93" data-mp="3lgopimyzeaqt">
            📧 soportetubrujuladigital@gmail.com
          </a>
          <a href="https://www.tubrujuladigital.online" className="hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violeta-300" data-id="element-94" data-mp="2evx8uurmh6z7">
            🌐 www.tubrujuladigital.online
          </a>
        </div>

        <p className="mt-8 text-xs text-violeta-100/50" data-id="element-95" data-mp="3v5dgcqo0r6sf">
          © Tu Brújula Digital™ 2026 — Todos los derechos reservados.
        </p>
        <p className="mt-2 text-xs text-violeta-100/50" data-id="element-96" data-mp="828ly3a19z83">
          🛡️ Garantía 7 días · 🔒 Pago seguro · ⚡ Acceso en 5 min
        </p>
      </div>
    </footer>;
}